<template>
  <img :src="baseSrc" v-on:load="loaded = true" class="ssim" :class="{loaded: loaded}" />
</template>

<script>
/// this works for home images, which have 320, 640, 960 and normal which is 1750
export default {
  props:{
    src: String
  },
  created () {
    this.init()
  },
  mounted() {
    window.addEventListener('resize', this.init)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.init)
  },
  data () {
    return {
      winwidth: 1024,
      srcSet: '',
      baseSrc: '',
      loaded: false
    }
  },
  methods: {
    async init () {
      if(!this.src) {
        this.baseSrc = ''
        return
      }
      let winwidth = window.innerWidth
      if(winwidth < 360) {
        this.baseSrc = this.getSizeImage(this.src, 320)
      }
      else if(winwidth < 700){
        this.baseSrc = this.getSizeImage(this.src, 640)
      }
      else if(winwidth < 1000){
        this.baseSrc = this.getSizeImage(this.src, 960)
      }
      else {
        this.baseSrc = this.src
      }
    },
    getSizeImage(src, sz) {
      let bs = src.split('/')
      let fname = bs.pop()
      return bs.join('/') + '/' + sz + '/' + fname
    }
  },
  watch: {
    src() {
      this.init()
    }
  }
}
</script>

<style scoped>
.ssim{
  opacity:0;
  transition:opacity 0.4s ease;
}

.ssim.loaded{
  opacity:1;
}
</style>